import { EMPTY_VALUE } from '../../fragments/empty-value';

const LOCALE = navigator.language;

const INTEGER_FORMAT = new Intl.NumberFormat(LOCALE, {
  maximumFractionDigits: 0,
});

const DECIMAL_FORMAT = new Intl.NumberFormat(LOCALE, {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const EUR_FORMAT = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
});

const PERCENT_FORMAT = new Intl.NumberFormat(LOCALE, {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const SIGNED_PERCENT_FORMAT = new Intl.NumberFormat(LOCALE, {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  signDisplay: 'exceptZero',
});

const RATIO_METRICS = ['ctr', 'engagementRate'];
const DURATION_METRICS = ['averageEngagementSeconds'];
const POSITION_METRICS = ['position'];
const CURRENCY_METRICS = ['revenueEur', 'estimatedMarginEur'];
const LOWER_IS_BETTER_METRICS = ['position'];

export const formatDuration = (seconds: number): string => {
  const rounded = Math.round(seconds);
  const minutes = Math.floor(rounded / 60);
  const rest = rounded % 60;

  return minutes > 0 ? `${minutes} min ${rest} s` : `${rest} s`;
};

export const formatMetric = (metric: string, value: number | null): string => {
  if (value === null) {
    return EMPTY_VALUE;
  }

  if (RATIO_METRICS.includes(metric)) {
    return PERCENT_FORMAT.format(value);
  }

  if (POSITION_METRICS.includes(metric)) {
    return DECIMAL_FORMAT.format(value);
  }

  if (CURRENCY_METRICS.includes(metric)) {
    return EUR_FORMAT.format(value);
  }

  if (DURATION_METRICS.includes(metric)) {
    return formatDuration(value);
  }

  return INTEGER_FORMAT.format(value);
};

export const formatChangePct = (value: number | null): string =>
  value === null ? EMPTY_VALUE : SIGNED_PERCENT_FORMAT.format(value);

export const formatRatio = (value: number | null): string =>
  value === null ? 'Not available' : PERCENT_FORMAT.format(value);

export const getChangeTone = (
  metric: string,
  value: number | null,
): 'success' | 'danger' | 'secondary' => {
  if (value === null || value === 0) {
    return 'secondary';
  }

  const isImprovement = LOWER_IS_BETTER_METRICS.includes(metric)
    ? value < 0
    : value > 0;

  return isImprovement ? 'success' : 'danger';
};
